import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../../theme-constants/colors';



export const summaryStyles = makeStyles((theme) => ({
    summarySection: {
        paddingTop: theme.spacing(4),
        borderTop: `1px solid ${tcsmColors.greyFive} `,
        '& .summary': {
            background: tcsmColors.greySeven,
            padding: theme.spacing(1.25),
            marginBottom: theme.spacing(2),
            '&-header': {
                marginBottom: theme.spacing(.75),
            },
            '&-row': {
                display: 'flex',
                justifyContent: 'space-between',
                width: '75%',
                marginBottom: theme.spacing(.75),
                paddingLeft: theme.spacing(.5),
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },

            },
            '&-subtotal': {
                borderTop: `1px solid ${tcsmColors.greyFour} `,
                paddingTop: theme.spacing(.75),

            },
            '&-total': {
                background: 'white',
                padding: theme.spacing(.5),
                marginTop: theme.spacing(.5),
                marginBottom: theme.spacing(.5),
                [theme.breakpoints.down('sm')]: {
                    paddingTop: theme.spacing(1.5),
                },
                '&-row': {
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '75%',
                },

            },
            '&-tooltip': {
                display: 'flex',
                alignItems: 'center',
                '&-inner': {
                    marginLeft: theme.spacing(.5),
                },
            },
            '&-decline': {
                paddingLeft: theme.spacing(.5),
            },
            '&-section': {
                display: 'flex',
                flexDirection:'column',
                '&-inner': {
                    marginLeft: theme.spacing(.5),
                },
            },
        },


    },

}));



